import { render } from "./SectionSelectionModal.vue?vue&type=template&id=d2271afe&scoped=true"
import script from "./SectionSelectionModal.vue?vue&type=script&lang=ts"
export * from "./SectionSelectionModal.vue?vue&type=script&lang=ts"

import "./SectionSelectionModal.vue?vue&type=style&index=0&id=d2271afe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d2271afe"

export default script